import { AgGridReact } from 'ag-grid-react';
import { MouseEvent, useEffect, useRef } from 'react';

import Actionbar from 'src/components/common/actionbar/Authactionbar';
import { Message } from 'src/components/common/form/Message';
import useUiuxStore from 'src/store/useUiuxStore';

import { Content_SYS2010_R01 } from './Content_SYS2010_R01';
import { SYS2010_R01Dto } from './Dto_SYS2010_R01';
import { SearchSection_SYS2010_R01 } from './SearchSection_SYS2010_R01';
import useSYS2010_R01Store from './Store_SYS2010_R01';
import { Table_SYS2010_R01 } from './Table_SYS2010_R01';

/**
 * 메뉴 관리 컨테이너 컴포넌트
 * 메뉴 관리 화면의 전체 레이아웃과 상태 관리를 담당
 */
export const Container_SYS2010_R01 = () => {
	const { SYS2010_R01List } = useSYS2010_R01Store();
	const { setMessage } = useUiuxStore();
	const gridRef = useRef<AgGridReact<SYS2010_R01Dto> | null>(null);

	const {
		clickable,
		setClickable,
		handleExcelClick,
		defaultSYS2010_R01Row,
		fetchData,
		initContainerData,
		handleInsertClick,
		handleSaveClick,
		handleDeleteClick,
	} = Content_SYS2010_R01({
		gridRef,
		setMessage,
	});

	useEffect(() => {
		if (SYS2010_R01List.length === 0) {
			handleInsertClick({} as MouseEvent<HTMLButtonElement>);
		}
	}, [SYS2010_R01List, handleInsertClick]);

	return (
		<div className="content-container">
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={handleInsertClick}
				onDeleteClick={handleDeleteClick}
				onSaveClick={handleSaveClick}
				onExcelClick={handleExcelClick}
				onInitClick={initContainerData}
			/>
			<SearchSection_SYS2010_R01 onEnterKeyDown={fetchData} />
			<div className="flex-1 flex">
				<div className="w-full h-full flex flex-col p-[12px] gap-[12px]">
					<Table_SYS2010_R01
						clickable={clickable}
						setClickable={setClickable}
						gridRef={gridRef}
						defaultSYS2010_R01Row={defaultSYS2010_R01Row}
						handleInsertClick={handleInsertClick}
					/>
				</div>
			</div>
			<Message />
		</div>
	);
};
